var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4243_12263)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M53.3337 52.2449C68.0612 52.2449 80.0003 40.5495 80.0003 26.1225C80.0003 11.6954 68.0612 0 53.3337 0C38.6061 0 26.667 11.6954 26.667 26.1225C26.667 40.5495 38.6061 52.2449 53.3337 52.2449Z",
    fill: "#E53B34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7773 46.0255V1.24414H66.0313V41.0498",
    stroke: "#374354",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8413 28.6104H78.7302V78.3674H0V28.6104H8.88889",
    stroke: "#374354",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7302 78.3679L39.3651 48.5137L0 78.3679",
    stroke: "#374354",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 28.6104L25.3968 53.4889",
    stroke: "#374354",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7298 28.6104L53.333 53.4889",
    stroke: "#374354",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0957 70.9043H40.6354",
    stroke: "#374354",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1748 70.9043H45.7145",
    stroke: "#374354",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0156 70.9043H35.5553",
    stroke: "#374354",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6982 41.0497V6.21973H17.7776",
    stroke: "#374354",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9045 43.5377C48.9176 43.5377 54.6029 37.9685 54.6029 31.0984C54.6029 24.2284 48.9176 18.6592 41.9045 18.6592C34.8913 18.6592 29.2061 24.2284 29.2061 31.0984C29.2061 37.9685 34.8913 43.5377 41.9045 43.5377Z",
    stroke: "#E53B34",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5869 6.21973H24.1266",
    stroke: "#374354",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.667 6.21973H29.2067",
    stroke: "#374354",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7461 6.21973H34.2858",
    stroke: "#374354",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5869 11.1953H62.2218",
    stroke: "#374354",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2541 27.3662L40.635 34.8298L35.5557 29.8541",
    stroke: "#E53B34",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4243_12263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmEmailIcon);
export default __webpack_public_path__ + "static/media/confirm-email-icon.7f75b4ca53412d921c9fa13fe6f76900.svg";
export { ForwardRef as ReactComponent };